module.exports = __webpack_public_path__ + "static/assets/88ec0217e99a2bef26430ab7cdab1c2b.png";